import {ExclamationCircleOutlined} from "@ant-design/icons";

export const TaskDueIndicator = ({alert, props}) => {
    // red
    let tagColor = "#f55442";
    if (alert === 2) {
        // purple
        tagColor = "#b605f7";
    }

    return <ExclamationCircleOutlined style={{color: tagColor}}/>
}